import { render, staticRenderFns } from "./specializedQC.vue?vue&type=template&id=678033ff&scoped=true"
import script from "./specializedQC.vue?vue&type=script&lang=js"
export * from "./specializedQC.vue?vue&type=script&lang=js"
import style0 from "./specializedQC.vue?vue&type=style&index=0&id=678033ff&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "678033ff",
  null
  
)

export default component.exports